import { actions } from "./actions";
import { mutations } from "./mutations";
const state = {
    data: {},
    fieldInfoList: [],
    fieldTable: {},
    tabnow: 'ruleP'
};

export default {
    state,
    actions,
    mutations
};